import axios from '@/utils/request'

export function getList(params) {
  return axios.get('/admin_api/v1/account/user', {
    params,
    timeout: 10000,
  })
}

export function getDetail(uuid) {
  return axios.get('/admin_api/v1/account/user/' + uuid)
}

// 用户禁言/不禁言
export function putUserForbidden(user_id, data) {
  return axios.put(`/admin_api/v1/account/user/${user_id}/forbidden`, data)
}

// 重置密码
export function postUserResetPassword(data) {
  return axios.post(`/admin_api/v1/account/user/reset/password`, data)
}
